import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24.394",
  height: "28.932"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  stroke: "#000",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  "data-name": "Groupe 1369"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.197 27.932V1",
    "data-name": "Tracé 1278"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.979 11.783 12.197 1 1.414 11.783",
    "data-name": "Tracé 1279"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }